module.exports = __webpack_public_path__ + "media/assets/tick-945174b5262f3ef6a7a707e84ec8cfe0e9e787376fcda36fd9d6d8098ff47c62.svg";